import axios from 'axios';
import { setupErrorInterceptor } from './errorHandler';

const normalizeApiUrl = (value?: string): string => {
  const raw = (value || '/api').trim();
  if (!raw) {
    return '/api';
  }

  if (/^https?:\/\//i.test(raw)) {
    return raw.replace(/\/+$/, '');
  }

  const cleaned = raw.replace(/^\/+/, '').replace(/\/+$/, '');
  return `/${cleaned || 'api'}`;
};

const API_URL = normalizeApiUrl(import.meta.env.VITE_API_URL);

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Configurar error handler humanizado
setupErrorInterceptor(api);

export default api;
